import axios from '@/shared/api/axios';
import { WorkspaceResponseDTO } from '../types';

interface FindWorkspaceResponse {
  success: boolean;
  data: WorkspaceResponseDTO;
  message?: string;
}

export const findWorkSpaceIdUsingCid = async (cid: string): Promise<FindWorkspaceResponse> => {
  const response = await axios.get<FindWorkspaceResponse>(`/v1/hub/workspaces/company/${cid}`);
  return response.data;
};
